<template>
    <footer class="foot">
      <img class="foot-bg" src="../assets/foot.png"/>
      <div class="foot-content">
        <img class="foot-icon" src="../assets/foot-icon.png"/>
        <div class="foot-nav">
          <span><router-link to="/">关于蝶金小贷</router-link></span>
          <span><router-link to="/HelpCenter">帮助中心</router-link></span>
          <span><a href="http://8.kingdee.com" target="_blank">金蝶信科官网</a></span>
          <span><a href="http://www.kingdee.com" target="_blank">金蝶官网</a></span>
        </div>
        <div class="foot-line"></div>
        <div class="">广州市蝶金小额贷款有限公司</div>
        <div class="foot-phone"><img class="phone-icon" src="../assets/phone-icon.png"/>4008-830-822（ 09:00-18:00 ）</div>
        <div class="foot-tip">版权信息</div>
      </div>
      <div class="verifyseal" >
        <!--<a href="https://ss.knet.cn/verifyseal.dll?sn=e19091244010079341da5h000000&amp;ct=df&amp;pa=cshtF8dA7u3cMKMj" oncontextmenu="return false;" style="display:inline-block !important;width:131px !important;height:47px !important;" target="_blank">
          <img id="d25e135gvkk0orcvdh" class="" height="47px" alt="可信网站" style="opacity: 1; display: block !important; width: 131px !important; height: 47px !important;border: none !important;" src="https://rr.knet.cn/static/images/newLogo/star4.png">
          <img id="6ourcmbm1ck0orcvdh" class="act" height="47px" alt="可信网站" style="opacity: 0; display: block !important; width: 131px !important; height: 47px !important; border: none !important;" src="https://rr.knet.cn/static/images/newLogo/6.png">
        </a>-->
        <div id="verifyseal"></div>
        <div class="footer-copyright">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402001697" target="_blank">
            <img src="../assets/policeIcon.png" alt="" style="vertical-align: sub; padding: 0px 5px;">
          </a>
          <a href="https://beian.miit.gov.cn/#/Integrated/recordQuery" target="_blank">
            粤ICP备 17012955号
          </a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010402001697" target="_blank" style="padding-left: 8px;">
            粤公网安备 44010402001697号
          </a>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
  name: 'Foot',
  props: {
  },
  mounted() {
    const oScript = document.createElement('script');
    oScript.type = 'text/javascript';
    oScript.id = 'kXScript' ;
    oScript.src = 'https://kxlogo.knet.cn/seallogo.dll?sn=e22121644010084899totr8139&h=47';
    const verifysealDoc = document.getElementById('verifyseal');
    verifysealDoc.appendChild(oScript);
  },
  methods: {

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .footer-copyright {
    margin-top: 12px;
    font-size: 12px;
    color:rgba(255, 255, 255, 0.8);
    text-align: center;
  }

  .verifyseal {
    text-align: center;
  }
    @media screen and (min-width: 800px){
      .foot{
        position: absolute;
        width: 100%;
        margin-top: 100px;

        .foot-bg{
          width: 100%;
          min-height: 406px;
        }
        a{
          text-decoration: none;
          color:rgba(255, 255, 255, 0.8);
        }
        .foot-content{
          position: absolute;
          top: 8%;
          left: 50%;
          text-align: center;
          transform: translateX(-50%);
          color:#FFFFFF;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(255,255,255,0.8);

          .phone-icon{
            margin-right: 5px;
            width: 12px;
            height: 12px;
          }
          .foot-nav{
            list-style: none;
            display: flex;
            //margin-top: 59px;

            span{
              flex: 1;
              min-width: 120px;
            }
          }
          .foot-line{
            width: 661px;
            height: 7px;
            opacity: 0.5;
            border-bottom: 1px dashed #ef7d06;
            margin: 10px auto;
          }
          .foot-tip{
            height:18px;
            font-size:13px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(255,255,255,0.3);
            line-height:18px;
            //margin-top: 38px;
          }
        }
        .verifyseal{
          position: absolute;
          bottom: 7%;
          left: 50%;
          transform: translateX(-50%);
        }

      }
    }
    @media screen and (max-width: 800px){
      .foot{
        position: relative;
        width: 100%;
        .foot-bg{
          width: 100%;
        }
        a{
          text-decoration: none;
          color:rgba(255, 255, 255, 0.8);
        }
        .foot-content{
          position: absolute;
          top: 8%;
          left: 50%;
          text-align: center;
          transform: translateX(-50%);
          color:#FFFFFF;
          font-family:PingFangSC-Regular;
          font-weight:400;
          color:rgba(255,255,255,0.8);
          .foot-icon{
            width: 50%;
          }
          .foot-phone{
            display: none;
          }
          .foot-nav{
            display: none;
            list-style: none;
            //margin-top: 59px;
            span{
              flex: 1;
              min-width: 120px;
            }
          }
          .foot-line{
            display: none;
            width: 100%;
            height: 7px;
            opacity: 0.5;
            border-bottom: 1px dashed #ef7d06;
            margin: 10px auto;
          }
          .foot-tip{
            display: none;
            height:18px;
            font-size:13px;
            font-family:PingFangSC-Regular;
            font-weight:400;
            color:rgba(255,255,255,0.3);
            line-height:18px;
            margin-top: 0.5rem;
          }
        }
        .verifyseal{
          display: none;
        }
      }
    }
</style>
